import { createContext, useContext } from "react";
import { Layer } from "../../types/Layer";
import { WfsGetFeatureRequestType } from "../../types/Wfs/WfsGetFeatureRequest";
import {
  WfsBadRequestResponse,
  WfsDataResponse,
  WfsDeferredRequestResponse,
  WfsDuplicateOrderResponse,
  WfsPaymentRequiredResponse,
} from "../../types/Wfs/WfsResponse";

interface DataSelectionContextType {
  layers: Layer[];
  getLayer: (layerName: string) => Layer | undefined;
  hasBoundaries: boolean;
  wfsOrder: (requestParameters: WfsGetFeatureRequestType) => void;
  addToBasket: (id: string) => void;
  wfsResult:
    | WfsDataResponse
    | WfsDeferredRequestResponse
    | WfsPaymentRequiredResponse
    | WfsBadRequestResponse
    | WfsDuplicateOrderResponse
    | undefined;
  wfsReset: () => void;
  loading: boolean;
}

const DataSelectionContext = createContext<
  DataSelectionContextType | undefined
>(undefined);

const useDataSelectionContext = () => {
  // get the context
  const context = useContext(DataSelectionContext);

  // if `undefined`, throw an error
  if (context === undefined) {
    throw new Error("useDataSelectionContext was used outside of its Provider");
  }

  return context;
};

export { DataSelectionContext, useDataSelectionContext };
